import React from 'react';
import { FiDownload, FiX } from 'react-icons/fi';
import './InstallPromptBanner.css';

const InstallPromptBanner = ({
  showAndroidPrompt,
  showIOSGuide,
  onInstall,
  onDismiss,
  isAndroid,
  isIOS
}) => {
  // Android Install Prompt
  if (showAndroidPrompt && isAndroid) {
    return (
      <div className="install-banner install-banner-android">
        <div className="install-banner-content">
          <FiDownload className="install-banner-icon" />
          <div className="install-banner-text">
            <h3>Install App</h3>
            <p>Get faster access to race results</p>
          </div>
        </div>
        <div className="install-banner-actions">
          <button
            className="install-btn-primary"
            onClick={onInstall}
          >
            Install
          </button>
          <button
            className="install-btn-secondary"
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            <FiX />
          </button>
        </div>
      </div>
    );
  }

  // iOS Guide Prompt
  if (showIOSGuide && isIOS) {
    return (
      <div className="install-banner install-banner-ios">
        <div className="install-banner-content">
          <FiDownload className="install-banner-icon" />
          <div className="install-banner-text">
            <h3>Add to Home Screen</h3>
            <p>Tap the Share button and select "Add to Home Screen"</p>
          </div>
        </div>
        <button
          className="install-btn-close"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          <FiX />
        </button>
      </div>
    );
  }

  return null;
};

export default InstallPromptBanner;
